import { ShortcutRegistry } from '@src/services/shortcuts/ShortcutRegistry';
import React from 'react';

import type { ShortcutRegistryLike } from '@src/services/shortcuts/types';

export const ShortcutRegistryContext =
  React.createContext<ShortcutRegistryLike | null>(null);

export function createShortcutRegistry(): ShortcutRegistryLike {
  return new ShortcutRegistry();
}
